import axios from 'axios'
import { oktaAuth } from 'lib/auth/oktaAuth'
import { FRONTEND_SERVICES_API_URL } from './constants'

// Dedicated axios instance for the gcloud-storage backend
export const gcloudStorageApi = axios.create({
  baseURL: FRONTEND_SERVICES_API_URL,
})

gcloudStorageApi.interceptors.request.use((config) => {
  // Okta id token, not access token, as the backend validates against the "aud" claim it carries (OKTA_AUDIENCE)
  const idToken = oktaAuth.getIdToken()

  if (idToken) {
    config.headers.set('Authorization', `Bearer ${idToken}`)
  }

  return config
})
